export default __webpack_public_path__ + "static/media/gallery_00.01fd7415.jpg";